'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _selectors = require('./selectors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var locationInput = void 0; /*
                              {
                                "type": "update_location",
                                "label": "Update Location",
                                "placeholder": "123 street, New York, NY 90999"
                              }
                            
                              This is for rendering the Update Location component.
                            */

function UpdateLocation(_ref) {
  var moduleClass = _ref.moduleClass,
      label = _ref.label,
      placeholder = _ref.placeholder,
      updateLocation = _ref.updateLocation;

  return _react2.default.createElement(
    'form',
    {
      className: 'type-update_location ' + moduleClass,
      onSubmit: function onSubmit(e) {
        e.preventDefault();
        updateLocation(locationInput.value);
      }
    },
    _react2.default.createElement(
      'div',
      { className: 'text-fields' },
      _react2.default.createElement('input', {
        type: 'text',
        placeholder: placeholder,
        ref: function ref(_ref2) {
          locationInput = _ref2;
        }
      }),
      _react2.default.createElement(
        'button',
        { className: 'tertiary narrow' },
        label
      )
    )
  );
}

exports.default = (0, _reactRedux.connect)(_selectors.mapStateToProps, _selectors.mapDispatchToProps)(UpdateLocation);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/modules/UpdateLocation/UpdateLocation.jsx
// module id = 1274
// module chunks = 0